import { Box, Button } from "@chakra-ui/react";
import React, { useState } from "react";
import Styles from "./code.module.css";
import OfferItem from "./OfferItem";

export default function Code() {
  const [content, setContent] = useState(1);
  const [offer, setOffer] = useState(CodeData);

  const filterOffer = (value, filterType) => {
    setContent(value)
    if (filterType === "All") {
      setOffer(CodeData)
    } else {
      const filterData = CodeData.filter((el) => el.type === filterType)
      setOffer(filterData)
    }
  }
  return (
    <div className={Styles.coupenHeading}>
      <h1>PharmEasy Offers & Coupon Codes</h1>
      <br />
      <div className={Styles.ans}><p>
        PharmEasy is one of India's leading online healthcare platforms that
        allows you to make great savings on your medicines and healthcare needs
        every day.From finding the prescribed medicine you need to the wellness
        product that is best suitable for you, PharmEasy is your one-stop
        destination for all your healthcare needs. Affordable prices offered by
        our partner retail pharmacies allow you to focus on your and your
        family's health while we take care of your budget.
        </p>
      <br />
     <p>
        We have got the best offers just for you. Watch out this space for the
        best PharmEasy offers on a range of healthcare products. Find new
        PharmEasy coupons and many such exciting offer codes updated every day.
        Simply use the PharmEasy coupon code to avail the best deals and offers.
        PharmEasy offers amazing payment and cashback deals too for new and
        existing users. Just apply the PharmEasy promo code at check-out and
        make the most of these offers.{" "}</p>
      </div>
      <br />

      <h2>
        Download the PharmEasy app today to buy medicines online with great
        savings.
      </h2>
      <br />
      <h2>Hurry! Avail these exclusive PharmEasy offers now.</h2>
      <Box className={Styles.btn}>
        <Button onClick={() => filterOffer(1, "All")} colorScheme={content === 1 ? "teal" : ""} color={content === 1 ? "white" : "black"}>All {content===1 ? `(${offer.length})`:""}</Button>
        <Button onClick={()=>filterOffer(2, "Payment")} colorScheme= {content===2 ? "teal":""} color={content===2 ? "white":"black"}>Payment {content===2 ? `(${offer.length})`:""}</Button>
        <Button onClick={()=>filterOffer(3, "Medicine")} colorScheme= {content===3 ? "teal":""} color={content===3 ? "white":"black"}>Medicine {content===3 ? `(${offer.length})`:""}</Button>
        <Button onClick={()=>filterOffer(4, "Diagnostic")} colorScheme= {content===4 ? "teal":""} color={content===4 ? "white":"black"}>Diagnostic {content===4 ? `(${offer.length})`:""}</Button>
        <Button onClick={()=>filterOffer(5, "Healthcare")} colorScheme= {content===5 ? "teal":""} color={content===5 ? "white":"black"}>Healthcare {content===5 ? `(${offer.length})`:""}</Button>
      </Box>
      <Box className={Styles.allItems}>{offer.map((el) => <OfferItem Data={el} />)}</Box>
    </div>
    
  );
}

const CodeData = [
  {
    id: 1,
    title: "FLAT 15% OFF on medicines + up to Rs.250 cashback",
    content:
      "Get FLAT 15% OFF on medicines + up to Rs.500 cashback via CRED Pay UPI.",
    img: "https://cms-contents.pharmeasy.in/offer/23881b129f7-LOGO.jpg",
    code: "No Code Required",
    Eligibility: [
      "This offer can be availed twice per user in the offer period. 25th November - 2oth December",
      "This offer is not applicable to payments made for diagnostics orders",
      "This offer cannot be clubbed with any other offer",
      "Can be used only once during the offer period per card",
      "Offer valid only on successful transactions, not valid on canceled orders.",
    ],
    Get: [
      "You have to go to the Pharmeasy app, select the products of your choice & make the payment using Cred UPI",
      "This offer is valid on minimum transaction of Rs. 999",
      "The offer can be availed twice per user in the offer period.",
      "The payment option is available on android device only",
      "Offer valid between 25th Nov - 20th Dec 2022",
      "The cashback will be in cred balance after completing the payment.",
      "Offer is valid only on online orders made on the Pharmeasy app using Cred UPI.",
    ],
    Condition: [
      "User will not be eligible for the discount if the order is cancelled.",
      "No instant discount is applicable in case of full refunds or cancellation of orders.",
    ],
    other: [
      "This offer can be availed twice per user in the offer period. 25th November - 2oth December",
      "If the customer has multiple accounts (user profile/registered numbers) on PharmEasy, they can avail of this offer only on one account per card.",
      "This offer is not applicable to payments made for diagnostics orders",
      "Only users who complete payment of orders placed within the offer period of 25th November - 2oth December qualify for the offer",
      "This offer cannot be clubbed with any other offer",
      "Offer valid only on successful transactions, not valid on canceled orders",
      "This offer is non-transferable, non-negotiable, and non-encashable.",
      "Any participation by a user in the offer is voluntary.",
      "Any user who has availed of the offer shall be deemed to have read and understood these terms and conditions and PharmEasy's terms and conditions.",
      "PharmEasy reserves the right to disqualify a user from availing of the offer.",
    ],
    type: "Payment",
    required: false,
  },
  {
    id: 2,
    title: "Get 3000 cashback points",
    content: "Valid once per user on transactions above ₹599.",
    img: "https://cms-contents.pharmeasy.in/offer/e11270f3e3f-paytmcashbackoptimized.png",
    code: "PTMDEC",
    Eligibility: [
      " This offer is applicable only when you Pay on Pharmeasy for ₹599 or more",
      "Offer can be availed 1 time during the campaign validity",
      "Offer is valid only on making payment on Pharmeasy using Paytm wallet",
    ],
    Get: [
      "Pay using Paytm Paytm wallet on PharmEasy and avail cashback points.",
    ],
    Condition: [
      " User will not be eligible for cashback points if the order is cancelled.",
      "No cashback points in case of full refunds or cancellation of orders.",
      "In case of partial refund, cashback will be rolled back for the proportionate amount.",
    ],
    other: [
      "Offer Eligibility",
      "This offer is applicable only when you Pay on Pharmeasy for ₹599 or more",
      "Offer can be availed 1 time during the campaign validity",
      "Offer is valid only on making payment on Pharmeasy using Paytm wallet",
      "Offer Duration",
      "On your first transaction, the offer will be automatically activated.",
      "Pay on Pharmeasy 1 time before 31-12-2022, 23:59:00 to earn flat 3000 cashback points",
      "Rewards",
      "Each reward will be received within 24 hours of completion of transaction on which the reward is eligible.",
      "All scratch cards issued from this offer will expire after 7 days",
      "Paytm reserves its absolute right to withdraw and/or alter any terms and conditions of the offer at any time without prior notice.",
    ],
    type: "Payment",
    required: true,
  },
  {
    id: 3,
    title: "Get up to Rs.600 cashback via Amazon Pay",
    content: "Offer valid on transactions above ₹399.",
    img: "https://cms-contents.pharmeasy.in/offer/79c9e323814-AMAZON.jpg",
    code: "AMZNDEC",
    Eligibility: [
      "Offer is valid only on online orders made on the Pharmeasy website or app using Amazon Pay.",
      "If the users are unable to see Amazon pay as a payment option on their android mobile device during the checkout process, users will have to update the PharmEasy app to the latest app version from the Google play store or iOS app store .",
      "Users should re-initiate the payment process after updating to the latest PharmEasy app to see Amazon pay as a payment option and complete the payment process successfully to avail the cashback.",
      "Offer is valid only on online orders made on the Pharmeasy website or app using Amazon Pay under Wallets. Offer is not valid on Amazon Pay UPI option under UPI tab.",
    ],
    Get: [
      "Log into PharmEasy, select the products of your choice & make the payment using Amazon Pay as the payment option.",
    ],
    Condition: [
      "User will not be eligible for cashback if the order is cancelled.",
      "No cashback in case of full refunds or cancellation of orders.",
    ],
    other: [
      "You have to go to the Pharmeasy website or app, select the products of your choice & make the payment using Amazon Pay as the payment option.",
      "Get a minimum cashback of Rs.15.",
      "The offer can be availed once per user in the offer period.",
      "Offer valid between 1st Dec-31st Dec 2022",
      "The cashback will be credited instantly as Amazon Pay balance after completing the payment.",
      "Offer is valid only on online orders made on the Pharmeasy website or app using Amazon Pay.",
      "This Offer will not be applicable if you, the Merchant or Amazon cancels the order fully or partially and in such a case, participation in the Offer will be deemed withdrawn. However, if you place another valid order after this during the offer period, the new order will be eligible for the cashback.",
      "The offer is currently applicable only for android and Web users only.",
      "If the users are unable to see Amazon pay as a payment option on their android mobile device during the checkout process, users will have to update the PharmEasy app from the Google play store.",
      "Users should reinitiate the payment process after updating the android app to see Amazon pay as a payment option and complete the payment process successfully to avail the cashback.",
      "Cashback for a Qualifying Transaction will be provided in the form of Amazon Pay Balance. Amazon Pay balance is a sum of all balances associated with Amazon Gift Cards. Amazon Gift Cards are issued Qwikcilver Solutions Private Limited and are subject to the Gift Card Terms and Conditions available at http://www.amazon.in/gp/help/customer/display.html?nodeId=201822810",
      "This Offer can only be availed once by each customer. Additionally, and for the avoidance of doubt, Amazon Pay Balance will only be provided for the first Qualifying Transaction (and not for any subsequent transactions) made by the customer during the Offer Period.",
    ],
    type: "Payment",
    required: true,
  },
  {
    id: 4,
    title: "Flat Rs.150 Off on AU Bank debit and credit card",
    content: "Valid once per user on transactions above Rs.1200",
    img: "https://cms-contents.pharmeasy.in/offer/702efbbe2e6-au.jpg",
    code: "AUBANKDEC",
    Eligibility: [
      "Minimum transaction value: INR 1,200 on Pharmeasy Website or Mobile Application.",
      "Offer valid once per user per card per month during the Offer Period.",
      "Offer Period: 1st Dec 2022 to 31st Dec 2022.",
    ],
    Get: [
      "Pay using AU Bank Debit and Credit card on PharmEasy and avail flat Rs.150 instant discount.",
    ],
    Condition: [
      "User will not be eligible for cashback points if the order is cancelled.",
      "No cashback in case of full refunds or cancellation of orders.",
      "In case of partial refund, cashback points will be rolled back for the proportionate amount.",
    ],
    other: [
      "Flat 150 discount on a minimum transaction of Rs. 1200",
      "Offer Period - 1st Dec 2022 to 31st Dec 2022",
      "Offer is valid for AU Bank Debit & Credit Card",
      "Applicable on Pharmeasy website and app",
      "The balance amount, after the discount is availed, will have to be paid by the customer at the time of purchase",
      "The offer cannot be redeemed for cash or clubbed with any other offer or promotion",
      "Cardholders are required to use their AUSF Bank Debit & Credit Card to pay for the services/product under the offers to avail the discounts.",
      "Offers made by the participating establishments may not be used in combination with any other offer that is in force. The offers are subject to force majeure events",
      "Taxes additional as applicable, Tax liability, if any, will be borne by the Cardholder.",
      "Bank reserves the right to withdraw or alter any of the terms and conditions of the offer at any time without prior notice",
      "Bank is neither responsible for nor guarantees the product/services of participating establishments.",
      "Bank shall not be liable for any defects or deficiency of the product or service so obtained/availed of by the Cardholder",
      "Bank shall not be liable for any loss or damage whatsoever that may be suffered, or for any personal injury that may be suffered as a result of availing of the offer",
      "All disputes under the Program shall be submitted to the jurisdiction of courts at Jaipur only.",
      "Regular Debit & Credit Card Terms and Conditions apply.",
      "Offer applicable on the following bins:",
      "AU bin BIN TYPE",
      "430217 AU Bank Debit Card",
      "430295 AU Bank Debit Card",
      "430320 AU Bank Debit Card",
      "430421 AU Bank Debit Card",
      "430462 AU Bank Debit Card",
      "429060 AU Bank Debit Card",
      "418276 AU Bank Debit Card",
      "443464 AU Bank Debit Card",
      "456519 AU Bank Debit Card",
      "652307 AU Bank Debit Card",
      "608087 AU Bank Debit Card",
      "608088 AU Bank Debit Card",
      "466505 AU Bank Credit Card",
      "465523 AU Bank Credit Card",
      "457036 AU Bank Credit Card",
      "406977 AU Bank Credit Card",
    ],
    type: "Payment",
    required: true,
  },
  {
    id: 5,
    title: "Flat 10% off upto Rs.150 on HSBC cashback credit card",
    content: "Valid once per user on transactions above Rs.1000",
    img: "https://cms-contents.pharmeasy.in/offer/9e4ef43119d-hsbc.jpg",
    code: "No Code Required",
    Eligibility: [
      "Minimum transaction value: INR 1,000 on Pharmeasy Website or Mobile Application.",
      "Offer valid once per user per card per month during the Offer Period.",
      "Offer Period: 1st Dec 2022 to 31st Dec 2022.",
      "Offer valid exclusively only on HSBC Cashback Credit Card (Card starting with 431104)",
    ],
    Get: [
      "Pay using HSBC cashback credit card on PharmEasy and avail flat 10% discount upto Rs.150",
    ],
    Condition: [
      "No cashback in case of full refunds or cancellation of orders.",
      " In case of partial refund, cashback will be rolled back for the proportionate amount.",
    ],
    other: [
      "Flat 10% Discount is up to INR 150",
      "Minimum transaction value: INR 1,000 on Pharmeasy Website or Mobile Application.",
      "Offer valid once per user per card per month during the Offer Period.",
      "Offer Period: 1st Dec 2022 to 31st Dec 2022.",
      "Offer valid exclusively only on HSBC Cashback Credit Card (Card starting with 431104)",
      "Offer is not valid on any other HSBC Credit Card variant.",
      "Other terms and conditions",
      "The offer is brought to you by The Hongkong and Shanghai Banking Corporation Limited, India (HSBC., in association with its alliance partner: Axelia Solutions Pvt. Ltd. ('PharmEasy'), and any participation in the said offer is voluntary.",
      "During the offer period cardholders can avail the offer only on using their valid HSBC Cashback Credit Card (Card..",
      "Transactions where payments are made with HSBC Cashback Credit Cards using any e-wallet will not be eligible for the Offer. Cardholders / Customers understand and agree that transactions / payments made through Mobile Credit Card or Tokenized Credit Card facility offered by HSBC will not be valid for availing the Offer.",
      "Cardholders will need to enter the full 16 digit HSBC Cashback Card Number while making the payment to avail the Offer.",
      "This offer is applicable to existing and new resident HSBC Cashback Credit cardholders, excluding corporate cardholders (hereinafter referred to as Cardholders.. Credit cardholders who have not repaid their minimum payment due within 30 days of their payment due date as mentioned on the credit card statement, will not be eligible for this offer.",
      "Add-on Cashback Credit Cardholders will be separately and additionally eligible for the offer.",
      "Terms and conditions of PharmEasy would apply with respect to cancellation of orders, refund and replacement. For more details, visit the PharmEasy website for more details. This offer is subject to the terms and conditions of PharmEasy as well, and cardholders are required to refer to, read, understand, accept and agree to be bound by them.",
      "PUBLIC",
      "Prior to availing the offer by making any purchases on PharmEasy website and/or mobile application, the cardholder should refer, read, understand, accept and agree to the user agreement and terms and conditions of the said website and mobile",
      "application, and proceed only if the cardholder agrees to abide by the same. The cardholder might be required to give personal information and other details online. The cardholder should read and understand the privacy policy of the website and mobile",
      "application, prior to providing any such information. Any disclosure of information made by the cardholder towards availing of or fulfilment of the offer is at the sole discretion of the cardholder and HSBC will not be responsible for the same. Merchants may use the personal information shared by the customer for any other purpose (like marketing, etc.) and HSBC shall not be held liable for such usage of personal information.",
      "Appropriate discount will be applied only on using valid Card on purchases made on PharmEasy's E-commerce website the mobile website or mobile application during the promotion period for the minimum Net Transaction Value as per the offer.",
      " The Net Transaction Value is the total purchase value arrived at before availing discount under this offer. The cardholders are advised to check the applicability of the discount before making the payment.",
      " The offer is not valid on net banking, commercial and corporate cards issued by HSBC.",
      "HSBC and/or PharmEasy reserve the right to cancel an order in case of any fraudulent activity including creating duplicate accounts, aliasing, placing multiple orders or violating the terms and conditions. Upon cancellation, the order will not be reinstated. HSBC shall not be liable for any refunds or compensation in case of said cancellations",
      "The discount amount offered will not be settled in cash under any circumstances whatsoever.",
      "The offer will only be applicable on transactions where appropriate and valid promo code has been applied by the cardholder before executing/making the payment.",
      "Product warranty will be regulated by the terms and conditions mentioned on the warranty card of respective product/manufacturer.",
      "Any defects, deficiency, claims, issues, damages or losses arising with respect to the Product/Services shall be the sole responsibility and liability of the manufacturer/seller or the service provider and HSBC will not be responsible for the same.",
      "Any query regarding the offer will be entertained during the Offer Period only.",
      "In case of complete cancellation of the order by the cardholder, the transaction will not qualify for the offer. In case of partial cancellation of the order, the cardholder shall qualify for the offer only on the basis of the net amount payable.",
      "The offer is valid in India for adults of a sound mind only.",
      "This offer shall be subjected to all applicable central/or state laws, rules and regulations.",
      "This document is an electronic record in terms of Information Technology Act, 2000, and the rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act,",
      "2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.",
      "HSBC and PharmEasy reserve the right to add, alter, modify, change or vary all or any of these terms and conditions or to replace, wholly or in part, this offer with another, whether similar to this offer or not, or to withdraw it completely at any point in time at its sole discretion. The offer may/may not be extended as mutually agreed by HSBC and",
      "Usage of the Card is governed by applicable terms and conditions. Please visit www.hsbc.co.in for detailed terms and conditions.",
      "HSBC reserves the sole right to decide on whether a purchase meets the eligibility criteria listed above.",
      "All decisions with respect to the offer shall be at the sole discretion of HSBC and the same shall be final, binding and non-contestable. Other than the specific entitlements available to the cardholder under the offer, any other claims with regards to the offer against HSBC are deemed waived.",
      "HSBC does not make any warranties or representation about the quality, merchantability, suitability or availability of the services offered under this offer. Any dispute regarding these must be addressed in writing, by the customer, directly with",
      "HSBC will not be liable for any direct or indirect loss or damage whatsoever that may be suffered, as a result of participating in the offer.",
      "The offer is subject to force majeure events.",
      "Tax liability, if any, will have to be borne by the cardholder.",
      "Please note that basis Goods and Services Tax (GST. regulations and notified GST rates, Central GST and State/Union Territory GST or Inter-State GST, will be levied on the discounted price, as applicable.",
      "Any disputes arising out of or in connection with the Card shall be subject to the exclusive jurisdiction of courts at Mumbai only. The existence of any dispute shall not, by itself, constitute any claim against HSBC.",
      "By participating in the offer, cardholders are assumed to have accepted all the aforementioned terms and conditions in their totality.",
    ],
    type: "Payment",
    required: false,
  },
  {
    id: 6,
    title: "Get up to ₹650 cashback via Mobikwik. Use code MBK650 on Mobikiwik",
    content:
      "Use code MBK650 while paying on Mobikwik, enjoy up to ₹650 cashback on PharmEasy (valid on transactions above ₹800).",
    img: "https://cms-contents.pharmeasy.in/offer/8cdf65ac110-mobiwiklogo.png",
    code: "MBKDEC",
    Eligibility: [
      "Get Cashback upto Rs 650 on Mobikwik wallet!",
      "Assured cashback that can be availed is ₹50",
      "Offer can be availed on a minimum transaction of ₹800",
      "Offer can be availed only once during the offer period",
      "Coupon Code required to avail the offer - MBK650 on Mobikwik",
      "Cashback will be credited into your MobiKwik wallet within 24 hours.",
      "Valid from 1st Dec-31st Dec 2022",
      "T&C applied*",
    ],
    Get: [
      " Just Pay on PharmEasy using your Mobikwik wallet.",
      "Apply code MBK650 on a minimum transaction of Rs.800 via Mobikwik to avail of the cashback.",
    ],
    Condition: [
      "If the order is cancelled or left undelivered at PharmEasy's end, the merchant will initiate a refund. After the refund is initiated, the amount will be credited back to the wallet within 7-10 days.",
    ],
    other: [
      "MobiKwik offer displayed on PharmEasy site will be valid only if it's also displayed on MobiKwik Website and App.",
      "In the event of any dispute, the decision of PharmEasy is final. PharmEasy reserves the right to withdraw and/or alter any terms & conditions of this offer without prior notice.",
      "Mobikwik shall be solely responsible for delivery and satisfaction of the Cashback offered to the customers. Pharmeasy does not hold any warranty or underwrite the shows offered by Mobikwik. For any queries/complaints regarding cashback kindly get in touch with Mobikwik on disputes@mobikwik.com",
    ],
    type: "Payment",
    required: true,
  },
  {
    id: 7,
    title: "Flat 10% cashback up to ₹100, Valid once per user",
    content: "Flat 10% cashback up to ₹100, Valid once per user",
    img: "https://cms-contents.pharmeasy.in/offer/29e0c8c1469-LOGO_Freecharge%20(1).png",
    code: "FRCNOV",
    Eligibility: [
      "Cancelled orders will not be eligible for this offer.",
      "Customer needs to have a Freecharge account & must pay using Freecharge Pay Later",
      " Applicable only once per user.",
      "This offer is open to all Freecharge Account holders whose accounts are valid and verified",
      " KYC update is mandatory for availing the cashback on Freecharge",
    ],
    Get: ["Just Pay on PharmEasy using Freecharge Pay Later"],
    Condition: [
      "The entire invoice value has to be settled using the Freecharge Pay Later, partial payment not allowed.",
      " In case of complete or partial order cancellation / return, entire cashback amount will be deducted from the total refund due.",
      "Cashback amount will be in form of e-Voucher and valid for 6 months from the date of credit in Freecharge account.",
      "In case of order cancellation, refund by Freecharge Pay Later will be processed within 7 to 10 working days.",
    ],
    other: [
      "To avail this offer, the customer needs to undertake a successful transaction on Pharmeasy.",
      "The customer shall receive flat 10% Cashaback up to ₹100 in the form of Freecharge Gift Instrument within 72 (seventy two) hours from the date of transaction which can be redeemed on the Freecharge website or Freecharge application or any other merchant website wherein Freecharge Balance is acceptable, within 1095 days from the date of the credit and is non-transferable.",
      "This offer is applicable once per user on Pharmeasy website, Mweb & app.",
      "This cashback offer is valid from 3rd Nov - 31st Dec 2022.",
      "This offer is not applicable on Medlife/Pharmeasy transactions via UPI.",
      "The Offer is valid once per user per FreechargeAccount/device/mobile number till 31st Aug 2022.",
      "In case of cancellation of order, refund shall be processed in the Freecharge Balance within 7 to 10 working days.",
      "The entire invoice amount has to be settled using Freecharge Balance, partial payment through Freecharge Balance is not allowed.",
      "In case of complete or partial order cancellation/return, the entire cashback amount will be deducted from the total refund.",
      "Freecharge reserves the right to disqualify any Freecharge Account from the benefits of this offer in case of any fraudulent activity/suspicious transactions.",
      "Freecharge reserves the right to modify/change all or any of the terms applicable to this offer or discontinue this offer without assigning any reasons or without any prior intimation whatsoever. In case of any disputes, Freecharge's decision shall be final.",
      "This offer is also subject to Freecharge Terms & Conditions available on the Freecharge website.",
    ],
    type: "Payment",
    required: true,
  },
  {
    id: 8,
    title: "Get FLAT ₹80 cashback via Airtel Payments Bank.",
    content:
      "Offer valid on transactions above ₹600 for first-time users of Airtel Payments Bank/Airtel Money Wallet on Pharmeasy.",
    img: "https://cms-contents.pharmeasy.in/offer/66c681514ce-LOGO-32.png",
    code: "ARTLDEC",
    Eligibility: [
      "The offer is available only for Airtel Payments Bank (APBL) customers :",
      "a) wallet customers ( Full KYC customers),",
      "b) savings account customers. KYC is mandatory to avail of the cashback.",
      "The offer is applicable only for first-time users",
      "Minimum transaction amount for the offer is Rs.600",
    ],
    Get: [
      " Cashback would be credited within 72 business hours in the user's Airtel Payments Bank wallet or savings account.",
      "Offer is applicable once per user during offer duration",
      "Pay through Airtel Wallet Valid on your PharmEasy order",
      "Customer must make the payment for the first time on pharmeasy",
    ],
    Condition: [
      "User will not be eligible for cashback if the order is cancelled.",
      "No cashback in case of full refunds or cancellation of orders.",
      "In case of partial refund, cashback will be rolled back for the proportionate amount.",
    ],
    other: [
      "The offer is available only for Airtel Payments Bank (APBL. customers : a) wallet customers (No KYC, Min KYC & Full KYC customers), b) savings account customers",
      "Users can avail Flat Rs. 80 cashback at Pharmeasy website & App by paying through Airtel Payments Bank or Airtel Money Wallet",
      "Maximum cashback amount per transaction will be Rs. 80",
      "Offer is applicable only for first time users of Airtel Payments Bank/Airtel Money Wallet on Pharmeasy",
      "Offer is applicable once per user during offer duration",
      "Limited period offer from 1st Dec-31st Dec 2022",
      "Minimum purchase of Rs. 600 is mandatory in order to avail this offer",
      "Cashback would be credited within 72 business hours in the user's Airtel Payments Bank wallet or savings account.",
      "Airtel Payments Bank reserves the right to disqualify any Airtel Payments Bank wallet holder(s. or Airtel Payments Bank savings account holder(s) from the benefits of this offer in case of any fraudulent activity/suspicious transactions.",
      "Airtel Payments Bank also reserves the right to discontinue this offer without assigning any reasons or without any prior intimation whatsoever.",
      "In addition to the above, this offer is also subject to Airtel Payments Bank's General Terms & Conditions available on http://www.airtel.in/personal/money/terms-of-use.",
      "Airtel Payments Bank does not warrant or guarantee availability of inventory on Pharmeasy Online platform.",
      "For further details, please send your queries to wecare@airtelbank.com",
      "Offer is not valid for Bharti Airtel & Airtel Payments Bank Employees",
    ],
    type: "Payment",
    required: false,
  },
  {
    id: 9,
    title: "Flat 25% OFF + FREE Delivery on 3 medicine orders",
    content:
      "Coupon applicable on first 3 medicine orders above Rs. 999.   Hurry! Order Now.",
    img: "https://cms-contents.pharmeasy.in/offer/e48df3b2675-Offer_YES.jpg",
    code: "STAR25",
    Eligibility: [
      "Please use the code STAR25 while placing the medicine order.",
      "All eligible users will get Flat 15% platform discount + Additional 10% discount on the total cart value., offer valid on medicines only.",
      "Offer is valid for new users only.",
      "Minimum order value is Rs.999 (Transaction value.",
      "Offer is valid only for one-time usage per user.",
      "Max flat discount available up to Rs 799",
      "PharmEasy reserves its absolute right to withdraw and/or alter any terms and conditions of the offer at any time without prior notice.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to the offer.",
      " Place your order via PharmEasy",
      "Please use the code STAR25 while placing the medicine order.",
      "The discount will be shown in the cart once the code is applied successfully.",
      "After the coupon code is applied, please proceed to complete the order process.",
      "The customer will get the cashback after the order is delivered successfully.",
    ],
    Condition: [
      "In case the order is cancelled or rejected the participation will be disqualified.",
      "The user will not be eligible for cashback if the order is cancelled, returned or partial return.",
    ],
    other: [
      "The code can be used once per customer only.",
      "Once the order is successfully delivered you will receive the PE Cashback within 10 days after the order is delivered.",
      "Credited cashback is valid only for 60 days.",
    ],
    type: "Medicine",
    required: true,
  },
  {
    id: 10,
    title: "Flat 27% OFF + up to Rs.5000 surprise cashback",
    content:
      "Coupon applicable on first 3 medicine orders above Rs. 1299. Hurry! Order Now.",
    img: "https://cms-contents.pharmeasy.in/offer/ac04bc614ab-Offer_YES.jpg",
    code: " VIBES27",
    Eligibility: [
      "Please use the code VIBES27 while placing the medicine order.",
      "All eligible users will get Flat 15% platform discount + Additional 12% discount Rs. 5000 surprise cashback.",
      "Offer is valid for on medicines only.",
      "Offer valid on new users only,",
      "Minimum order value is Rs.1299 (Transaction value.",
      "Offer is valid only for one-time usage per user.",
      "Max flat discount available up to Rs 999",
      "PharmEasy reserves its absolute right to withdraw and/or alter any terms and conditions of the offer at any time without prior notice.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to the offer.",
      "Place your order via PharmEasy",
      "Please use the code VIBES27 while placing the medicine order.",
      "The discount will be shown in the cart once the code is applied successfully.",
      " After the coupon code is applied, please proceed to complete the order process.",
      "The customer will get the cashback after the order is delivered successfully.",
    ],
    Condition: [
      "In case the order is cancelled or rejected the participation will be disqualified.",
      "The user will not be eligible for cashback if the order is cancelled, returned or partial return.",
    ],
    other: [
      "The code can be used once per customer only.",
      "Once the order is successfully delivered you will receive the PE Cashback within 10 days after the order is delivered.",
      "Credited cashback is valid only for 60 days.",
    ],
    type: "Medicine",
    required: true,
  },
  {
    id: 11,
    title: "Get FREE delivery",
    content: "Offer Valid on orders above Rs.749. Hurry! order now!",
    img: "https://cms-contents.pharmeasy.in/offer/794679adf6a-Offer_YES.jpg",
    code: "FREEDE",
    Eligibility: [
      "Please use the code FREEDE while placing the medicine order.",
      "All eligible users will get Flat 15% platform discount + Rs. 30 cashback in their PharmEasy wallet.",
      "offer valid on medicines only.",
      "Offer is valid for new users only.",
      "Minimum order value is Rs.749",
      "Offer is valid only for one-time usage per user.",
      "PharmEasy reserves its absolute right to withdraw and/or alter any terms and conditions of the offer at any time without prior notice.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to the offer.",
      "Place your order via PharmEasy",
      "Please use the code FREEDE while placing the medicine order.",
      "After the coupon code is applied, please proceed to complete the order process.",
      "For FREEDE offer, Rs.30 cashback will be processed to the user in PharmEasy wallet once the order is successfully delivered.",
      "The customer will get the cashback within 72 hours after the order is delivered successfully.",
    ],
    Condition: [
      "In case the order is cancelled or rejected the participation will be disqualified.",
      "The user will not be eligible for cashback if the order is cancelled, returned or partial return.",
    ],
    other: [
      "The code can be used once per customer only.",
      "Credited cashback is valid only for 60 days.",
      "Free delivery cashback of Rs.30 would be processed only post the user order fulfillment.",
    ],
    type: "Medicine",
    required: true,
  },
  {
    id: 12,
    title: "FLAT 15% OFF on medicines + up to Rs.250 cashback",
    content:
      "Get FLAT 15% OFF on medicines + up to Rs.500 cashback via CRED Pay UPI.",
    img: "https://cms-contents.pharmeasy.in/offer/23881b129f7-LOGO.jpg",
    code: "No Code Required",
    Eligibility: [
      "This offer can be availed twice per user in the offer period. 25th November - 2oth December",
      "This offer is not applicable to payments made for diagnostics orders",
      "This offer cannot be clubbed with any other offer",
      "Can be used only once during the offer period per card",
      "Offer valid only on successful transactions, not valid on canceled orders.",
    ],
    Get: [
      "You have to go to the Pharmeasy app, select the products of your choice & make the payment using Cred UPI",
      "This offer is valid on minimum transaction of Rs. 999",
      "The offer can be availed twice per user in the offer period.",
      "The payment option is available on android device only",
      " Offer valid between 25th Nov - 20th Dec 2022",
      "The cashback will be in cred balance after completing the payment.",
      "Offer is valid only on online orders made on the Pharmeasy app using Cred UPI.",
    ],
    Condition: [
      "User will not be eligible for the discount if the order is cancelled.",
      "No instant discount is applicable in case of full refunds or cancellation of orders.",
    ],
    other: [
      "This offer can be availed twice per user in the offer period. 25th November - 2oth December",
      "If the customer has multiple accounts (user profile/registered numbers) on PharmEasy, they can avail of this offer only on one account per card.",
      "This offer is not applicable to payments made for diagnostics orders",
      "Only users who complete payment of orders placed within the offer period of 25th November - 2oth December qualify for the offer",
      "This offer cannot be clubbed with any other offer",
      "Offer valid only on successful transactions, not valid on canceled orders",
      "This offer is non-transferable, non-negotiable, and non-encashable.",
      "Any participation by a user in the offer is voluntary.",
      "Any user who has availed of the offer shall be deemed to have read and understood these terms and conditions and PharmEasy’s terms and conditions.",
      "PharmEasy reserves the right to disqualify a user from availing of the offer.",
    ],
    type: "Medicine",
    required: false,
  },
  {
    id: 13,
    title:
      "Order medicines worth Rs.1000 and get FLAT Rs.1000 OFF on booking 2 Comprehensive Full Body checkup with Vitamin D and B12.",
    content:
      "Order medicines worth Rs.1000 and get FLAT Rs.1000 OFF on booking 2 Comprehensive Full Body checkup with Vitamin D and B12.",
    img: "https://cms-contents.pharmeasy.in/offer/40ef59a3196-Diagnostics-11-min.png",
    code: "GET1000",
    Eligibility: [
      "Offer valid for all users.",
      "This offer cannot be clubbed with any other offer or deal.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      "Place your order via PharmEasy app or website.",
      "Please use the code GET1000 while placing the order.",
      "Minimum Order of Rs.1000 required.",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      " Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
    ],
    other: [
      "Get FLAT Rs.1000 off on booking 2 comprehensive with Vitamin D and B12 Packages.",
      "Sample pick up from home and online reports will be provided",
      "Offer is applicable only once per user.",
      "Minimum order value required is Rs.2998.",
      "The offer is valid only in cities where service is available.",
      "This offer will be active over and above any current offers run by PharmEasy on their platform",
      "PharmEasy reserves the right to amend the terms & conditions, end the offer, or call back any or all of its offers without prior notice",
      "FREE sample collection only on first diagnostic test.",
      "This offer is valid in selected cities only.",
    ],
    type: "Medicine",
    required: true,
  },
  {
    id: 14,
    title:
      "Get FLAT Rs.1000 OFF on booking 2 Comprehensive Full Body checkup with Vitamin D and B12 Packages.",
    content:
      "Get FLAT Rs.1000 OFF on booking 2 Comprehensive Full Body checkup with Vitamin D and B12 Packages.",
    img: "https://cms-contents.pharmeasy.in/offer/beff77d2d65-Diagnostics-11-min.png",
    code: "COMBO1000",
    Eligibility: [
      "Offer valid for all users.",
      "This offer cannot be clubbed with any other offer or deal.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      "Place your order via PharmEasy app or website.",
      "Please use the code COMBO1000 while placing the order.",
      "Min order value eligible to get Flat Rs.1000 OFF Rs.2998",
      "Max Flat Off Offer of up to Rs.1000.",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      " Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
    ],
    other: [
      "Get upto FLAT Rs.1000 off on PharmEasy Labtests.",
      "Sample pick up from home and online reports will be provided",
      "Offer is applicable only once per user.",
      "No Minimum order value required.",
      " The offer is valid only in cities where service is available.",
      "This offer will be active over and above any current offers run by PharmEasy on their platform",
      "PharmEasy reserves the right to amend the terms & conditions, end the offer, or call back any or all of its offers without prior notice",
      "FREE sample collection only on first diagnostic test.",
      "This offer is valid in selected cities only.",
    ],
    type: "Diagnostic",
    required: true,
  },
  {
    id: 15,
    title: "Get FLAT Rs.550 OFF",
    content:
      "Get FLAT Rs.550 OFF on Comprehensive Full Body Checkup with Vitamin D & B12",
    img: "https://cms-contents.pharmeasy.in/offer/30c8d4a2e82-400x400.png",
    code: " YAY550",
    Eligibility: [
      "Offer valid only on First Diagnostic booking.",
      "This offer cannot be clubbed with any other offer or deal.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      " Place your order via PharmEasy app or website.",
      "Please use the code YAY550 while booking Comprehensive Full Body Checkup with Vitamin D & B12",
      "Min order value eligible to get Flat Rs.550 OFF is Rs.1549.",
      "Max Flat Off Offer of up to Rs.550.",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      "Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
    ],
    other: [
      "Get upto FLAT Rs.550 off on Comprehensive Full Body Checkup with Vitamin D & B12.",
      "Sample pick up from home and online reports will be provided",
      "Offer is applicable only once per user.",
      "Min order value eligible to get Flat Rs.550 OFF is Rs.1549.",
      "The offer is valid only in cities where service is available.",
      "This offer will be active over and above any current offers run by PharmEasy on their platform",
      "PharmEasy reserves the right to amend the terms & conditions, end the offer, or call back any or all of its offers without prior notice",
      "FREE sample collection only on first diagnostic test.",
      "This offer is valid in selected cities only.",
    ],
    type: "Diagnostic",
    required: true,
  },
  {
    id: 16,
    title: "Get FLAT Rs.350 OFF on orders above Rs 1499.",
    content: "Get FLAT Rs.350 OFF on orders above Rs 1499.",
    img: "https://cms-contents.pharmeasy.in/offer/7e9e0fac720-1_400x400_10KB.jpg",
    code: "LAB350",
    Eligibility: [
      "Offer valid for all users.",
      "This offer cannot be clubbed with any other offer or deal.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      "Place your order via PharmEasy app or website.",
      "Please use the code LAB350 while placing the order.",
      "Min order value eligible to get Flat Rs.350 OFF is Rs.1499.",
      "Max Flat Off Offer of up to Rs.350.",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      "Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
    ],
    other: [
      "Get upto FLAT Rs.350 off on PharmEasy Labtests.",
      "Sample pick up from home and online reports will be provided",
      "Offer is applicable only once per user.",
      "Minimum order value required is Rs 1499.",
      "The offer is valid only in cities where service is available.",
      "This offer will be active over and above any current offers run by PharmEasy on their platform",
      "PharmEasy reserves the right to amend the terms & conditions, end the offer, or call back any or all of its offers without prior notice",
      "FREE sample collection only on first diagnostic test.",
      "This offer is valid in selected cities only.",
    ],
    type: "Diagnostic",
    required: true,
  },
  {
    id: 17,
    title: "Get Free Plus membership by booking any premium package",
    content:
      "Book any premium package worth Rs.1999 and get Free Plus membership worth RS.499",
    img: "https://cms-contents.pharmeasy.in/offer/432848472a7-pluslogo.jpg",
    code: "GET3",
    Eligibility: [
      "Offer valid for Repeat users.",
      ":This offer cannot be clubbed with any other offer or deal.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      "Place your order via PharmEasy app or website.",
      "Please use the code GET3 while placing the order.",
      "Min order value eligible Rs.1999",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      " Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
    ],
    other: [
      "Book any premium package worth Rs.1999 and get Free Plus membership worth RS.499",
      "Sample pick up from home and online reports will be provided",
      "Offer is applicable only once per user.",
      "The offer is valid only in cities where service is available.",
      "This offer will be active over and above any current offers run by PharmEasy on their platform",
      "PharmEasy reserves the right to amend the terms & conditions, end the offer, or call back any or all of its offers without prior notice",
      "FREE sample collection only on first diagnostic test.",
      "Offer valid for Repeat users.",
      "This offer is valid in selected cities only.",
    ],
    type: "Diagnostic",
    required: true,
  },
  {
    id: 18,
    title: "Buy 2 or more tests and get up to 30% cashback.",
    content: "Buy 2 or more tests and get up to 30% cashback.",
    img: "https://cms-contents.pharmeasy.in/offer/4922989c113-3_400x400.png",
    code: "GETSAVE",
    Eligibility: [
      "Offer valid for all users.",
      "Offer valid on Pharmeasy Labs.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      "Place your order via PharmEasy app or website.",
      "Please use the code GETSAVE while placing the order.",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      " Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
      "Offer is on valid only on tests/profiles and not health packages.",
    ],
    other: [""],
    type: "Diagnostic",
    required: true,
  },
  {
    id: 19,
    title: "Get FLAT Rs.300 cashback on PharmEasy Labtests booked above Rs.999",
    content:
      "Get FLAT Rs.300 cashback on PharmEasy Labtests booked above Rs.999",
    img: "https://cms-contents.pharmeasy.in/offer/2fa71127c58-Diagnostics-02-min.png",
    code: "FIT300",
    Eligibility: [
      "Offer valid for all users.",
      "This offer cannot be clubbed with any other offer or deal.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      "Place your order via PharmEasy app or website.",
      "Please use the code FIT300 while placing the order.",
      "Min order value eligible to get the Flat Rs 300 Cashback offer is Rs.999",
      "Max Flat Cashback of Rs.300.",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      "Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
    ],
    other: [
      "Get FLAT Rs.300 cashback on PharmEasy Labtests booked above Rs.999",
      "Sample pick up from home and online reports will be provided",
      "Offer is applicable only once per user.",
      "Minimum order value Rs.999",
      "The offer is valid only in cities where service is available.",
      " This offer will be active over and above any current offers run by PharmEasy on their platform",
      "PharmEasy reserves the right to amend the terms & conditions, end the offer, or call back any or all of its offers without prior notice",
      "FREE sample collection only on first diagnostic test.",
      "This offer is valid in selected cities only.",
      "The cashback is valid for only 60 days, starting from the day it is credited.",
    ],
    type: "Diagnostic",
    required: true,
  },
  {
    id: 20,
    title: "Buy 3 Health Checkups worth Rs.1499 each and Pay for only 2.",
    content: "Buy 3 Health Checkups worth Rs.1499 each and Pay for only 2.",
    img: "https://cms-contents.pharmeasy.in/offer/843f75ab15f-4_400x400.png",
    code: "MEGASAVER",
    Eligibility: [
      "Offer valid for all users.",
      "This offer cannot be clubbed with any other offer or deal.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      "Place your order via PharmEasy app or website.",
      "Please use the code MEGASAVER while placing the order.",
      "Min order value for code applicability is Rs.4497.",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      "Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
    ],
    other: [
      "Sample pick up from home and online reports will be provided",
      "Offer is applicable only once per user.",
      "Min order value for code applicability is Rs.4497.",
      "The offer is valid only in cities where service is available.",
      "This offer will be active over and above any current offers run by PharmEasy on their platform",
      "PharmEasy reserves the right to amend the terms & conditions, end the offer, or call back any or all of its offers without prior notice",
      "FREE sample collection only on first diagnostic test.",
      "This offer is valid in selected cities only.",
      "The cashback is valid for only 60 days, starting from the day it is credited.",
    ],
    type: "Diagnostic",
    required: true,
  },
  {
    id: 21,
    title:
      "Get FLAT Rs.200 cashback on PharmEasy Labtests booked above Rs.699.",
    content:
      "Get FLAT Rs.200 cashback on PharmEasy Labtests booked above Rs.699.",
    img: "https://cms-contents.pharmeasy.in/offer/a755d10e494-Diagnostics-01-min.png",
    code: "FIT200",
    Eligibility: [
      "Offer valid for all users.",
      "This offer cannot be clubbed with any other offer or deal.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      "Place your order via PharmEasy app or website.",
      "Please use the code FIT200 while placing the order.",
      "Min order value eligible to get the Flat Rs.200 Cashback offer is Rs.699",
      "Max Flat Cashback of Rs.200.",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      "Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
    ],
    other: [
      "Get FLAT Rs.200 cashback on PharmEasy Labtests booked above Rs.699",
      "Sample pick up from home and online reports will be provided",
      "Offer is applicable only once per user.",
      "Minimum order value Rs.699",
      "The offer is valid only in cities where service is available.",
      "This offer will be active over and above any current offers run by PharmEasy on their platform",
      "PharmEasy reserves the right to amend the terms & conditions, end the offer, or call back any or all of its offers without prior notice",
      "FREE sample collection only on first diagnostic test.",
      "This offer is valid in selected cities only.",
      "The cashback is valid for only 60 days, starting from the day it is credited.",
    ],
    type: "Diagnostic",
    required: true,
  },
  {
    id: 22,
    title: "Get Flat Rs.50 Cashback on orders above Rs.300.",
    content: "Get Flat Rs.50 Cashback on orders above Rs.300.",
    img: "https://cms-contents.pharmeasy.in/offer/5db436ee3cd-1_400x400.png",
    code: "CSH50",
    Eligibility: [
      "Offer valid for all users.",
      "Offer valid on Pharmeasy Labs.",
    ],
    Get: [
      "Log into PharmEasy app or website.",
      "Check out our T&C page to read all the information related to this offer.",
      "Place your order via PharmEasy app or website.",
      " Please use the code CSH50 while placing the order.",
      "Min order value eligible to get Flat Rs.50 Cashback on MOV Rs.300",
      "Max Flat Cashback Offer of up to Rs.50.",
      "After the coupon code is applied, please proceed to complete the order process.",
    ],
    Condition: [
      " Offer valid once per user during the offer period.",
      "In no case, whatsoever, can the discount amount be refunded, en-cashed or partly en-cashed.",
      "In case of order cancellation on PharmEasy, the user will not be eligible for the voucher.",
    ],
    other: [
      "Get upto FLAT Rs.50 Cashback on PharmEasy Labtests.",
      "Sample pick up from home and online reports will be provided",
      "Offer is applicable only once per user.",
      "No Minimum order value required.",
      "The offer is valid only in cities where service is available.",
      "This offer will be active over and above any current offers run by PharmEasy on their platform",
      "PharmEasy reserves the right to amend the terms & conditions, end the offer, or call back any or all of its offers without prior notice",
      "FREE sample collection only on first diagnostic test.",
      "This offer is valid in selected cities only.",
      "The cashback is valid for only 60 days, starting from the day it is credited.",
    ],
    type: "Diagnostic",
    required: true,
  },
  {
    id: 23,
    title: "FLAT 15% OFF on medicines + up to Rs.250 cashback",
    content:
      "Get FLAT 15% OFF on medicines + up to Rs.500 cashback via CRED Pay UPI.",
    img: "https://cms-contents.pharmeasy.in/offer/23881b129f7-LOGO.jpg",
    code: "No Code Required",
    Eligibility: [
      "This offer can be availed twice per user in the offer period. 25th November - 2oth December",
      "This offer is not applicable to payments made for diagnostics orders",
      "This offer cannot be clubbed with any other offer",
      "Can be used only once during the offer period per card",
      "Offer valid only on successful transactions, not valid on canceled orders.",
    ],
    Get: [
      "You have to go to the Pharmeasy app, select the products of your choice & make the payment using Cred UPI",
      "This offer is valid on minimum transaction of Rs. 999",
      "The offer can be availed twice per user in the offer period.",
      "The payment option is available on android device only",
      "Offer valid between 25th Nov - 20th Dec 2022",
      "The cashback will be in cred balance after completing the payment.",
      "Offer is valid only on online orders made on the Pharmeasy app using Cred UPI.",
    ],
    Condition: [
      "User will not be eligible for the discount if the order is cancelled.",
      "No instant discount is applicable in case of full refunds or cancellation of orders.",
    ],
    other: [
      "This offer can be availed twice per user in the offer period. 25th November - 2oth December",
      "If the customer has multiple accounts (user profile/registered numbers) on PharmEasy, they can avail of this offer only on one account per card.",
      "This offer is not applicable to payments made for diagnostics orders",
      "Only users who complete payment of orders placed within the offer period of 25th November - 2oth December qualify for the offer",
      "This offer cannot be clubbed with any other offer",
      "Offer valid only on successful transactions, not valid on canceled orders",
      "This offer is non-transferable, non-negotiable, and non-encashable.",
      "Any participation by a user in the offer is voluntary.",
      "Any user who has availed of the offer shall be deemed to have read and understood these terms and conditions and PharmEasy's terms and conditions.",
      "PharmEasy reserves the right to disqualify a user from availing of the offer.",
    ],
    type: "Healthcare",
    required: false,
  },
  {
    id: 23,
    title: "100% Money Back Guarantee",
    content:
      "#NoQuestionsAsked | Easy & Safe Returns with Everherb & PharmEasy products only",
    img: "https://cms-contents.pharmeasy.in/offer/4fc5e4c1b0b-new.jpg",
    code: "No Code Required",
    Eligibility: [
      "A 100% money back guarantee is applicable on this product.",
      "This offer is not valid on bulk purchase wherein bulk purchase > 2 units.",
      "The offer is applicable for any product purchased during the period 6th December, 2022 to 20th December, 2022.",
      "Any user, who purchases the product during the above time-span and would like to return the product for whatever reason shall be eligible for a 30 day No questions asked return.",
      "In order to claim the refund, user needs to call the PharmEasy customer care helpline number 7666100300 or write at care@pharmeasy.in",
      "The refund will be credited to the PharmEasy wallet and can be used in full against all future orders on PharmEasy.",
      "The refund amount will be calculated net of any promotional discounts / coupons used by the user at the time of placing the order.",
      "PharmEasy reserves the right to amend or withdraw the scheme at any time in the future. However, orders placed before the amendment / withdrawal will be honoured in full.",
    ],
    Get: [
      "In order to claim the refund, user needs to call the PharmEasy customer care helpline number 7666100300 or write at care@pharmeasy.in",
      "The refund will be credited to the PharmEasy wallet and can be used in full against all future orders on PharmEasy.",
      "The refund amount will be calculated net of any promotional discounts / coupons used by the user at the time of placing the order.",
      "PharmEasy reserves the right to amend or withdraw the scheme at any time in the future. However, orders placed before the amendment / withdrawal will be honoured in full.",
    ],
    Condition: [
      "In case the order is cancelled or rejected the participation will be disqualified.",
      "The user will not be eligible for cashback if the order is cancelled, returned or partial return.",
    ],
    other: [
      "Is this valid on all the products on PharmEasy?",
      "No this offer is extended on select merchandise only, till stock lasts.",
      "How do I know which products qualify for a money back guarantee?",
      "All eligible products carry the money back guarantee logo on their images.",
      "How do I return the product?",
      "We strive for 100% satisfaction of our customers. However, if you don't like the product after using it, you can call us on 7666100300 or write to us at care@pharmeasy.in and we will refund you the amount.",
      "Where will my refund be processed?",
      "The refund will be processed to your PharmEasy Wallet.",
      "Are there any usage restrictions on the refunded amount?",
      "No, there is no restriction on the refunded wallet amount. The same can be used against any future orders.",
      "What proof do I need to submit in order to get the refund?",
      "The best part is we trust our customers and this is a no questions asked return policy. However, we would love to hear your feedback to help us",
      "improve. Thus we would encourage you to just send us or tell us what it was that you didn't like about the product.",
    ],
    type: "Healthcare",
    required: false,
  },
];
